package org.example.site_web.components.images

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.shapes.Path
import com.varabyte.kobweb.silk.theme.shapes.Rect
import kotlinx.coroutines.delay
import org.example.site_web.aiPalette
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.ElementScope
import org.w3c.css.masking.SVGMaskElement
import org.w3c.dom.svg.SVGElement

class SVGMaskAttrsScope private constructor(attrs: AttrsScope<SVGMaskElement>) :
    SVGElementAttrsScope<SVGMaskElement>(attrs) {
    companion object {
        operator fun invoke(attrs: SVGMaskAttrsScope.() -> Unit): AttrBuilderContext<SVGMaskElement> {
            return { SVGMaskAttrsScope(this).attrs() }
        }
    }
}

@Composable
fun ElementScope<SVGElement>.Mask(
    attrs: (SVGMaskAttrsScope.() -> Unit)? = null,
    content: ContentBuilder<SVGMaskElement>
) {
    GenericTag(
        "mask",
        "http://www.w3.org/2000/svg", attrs?.let { SVGMaskAttrsScope(it) }, content
    )
}
@Composable
fun BulbSvg(modifier: Modifier = Modifier, frame: Double) {
    Svg(
        attrs = modifier.toAttrs {
            viewBox(0, 0, 64, 64)
        }
    )
    {
        val armgradient = SvgId("armgradient")

        Rect() {
            x(0)
            y(0)
            width(64)
            height(64)
            fill(armgradient)
            attr("mask", "url(#bulbmask)")
        }
    }
}


//viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve" >
//
//<mask id="myMask">
//<path d="M33,49H23l0.609,4.261c0.235,1.648,1.467,2.978,3.092,3.339L33,58V49z" style="fill-rule:evenodd;clip-rule:evenodd;" fill="white" />
//<path d="M31,46h-3c0-8.611-1.687-14.515-2.814-17.5c-0.504-1.335,0.021-2.836,1.261-3.542l0.356-0.203C26.974,25.056,31,32.26,31,46
//z" fill="white"/>
//<rect x="2" y="23" width="5" height="3" fill="white"/>
//<rect x="8.5" y="6.625" transform="matrix(0.6148 -0.7887 0.7887 0.6148 -3.6405 11.5465)" width="3" height="5.75" fill="white"/>
//<rect x="7.125" y="37" transform="matrix(0.7888 -0.6146 0.6146 0.7888 -21.5517 14.2773)" width="5.75" height="3" fill="white"/>
//<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M31,49h10l-0.609,4.261c-0.235,1.648-1.467,2.978-3.092,3.339L31,58V49z" fill="white"/>
//<path d="M40.31,46H39c0-2.901,1.783-5.688,3.849-8.917c3.199-4.999,6.963-10.881,4.181-18.236
//c-2.433-6.432-8.37-10.938-15.246-10.847C23.06,8.118,16,15.25,16,24c0,5.033,2.736,9.31,5.151,13.083
//C23.217,40.312,25,43.099,25,46h-1.31c-0.904,0-1.67-0.61-1.926-1.477c-0.503-1.703-1.749-3.649-3.14-5.823
//c-3.237-5.059-7.496-11.716-4.735-20.141c2.61-7.965,9.96-13.659,18.342-13.559C42.601,5.125,51,13.6,51,24
//c0,5.911-3.118,10.785-5.624,14.701c-1.391,2.174-2.636,4.12-3.14,5.823C41.98,45.39,41.214,46,40.31,46z" fill="white"/>
//<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M28,56c0,2.209,1.791,4,4,4s4-1.791,4-4H28z" fill="white"/>
//<path d="M36,46h-3c0-13.74,4.026-20.944,4.197-21.244l0.359,0.205c1.237,0.707,1.761,2.206,1.257,3.539
//C37.687,31.483,36,37.388,36,46z" fill="white"/>
//<rect x="57" y="23" width="5" height="3" fill="white"/>
//<rect x="51.125" y="8" transform="matrix(0.7888 -0.6146 0.6146 0.7888 5.5653 35.1968)" width="5.75" height="3" fill="white"/>
//<rect x="52.5" y="35.625" transform="matrix(0.6148 -0.7887 0.7887 0.6148 -9.5632 57.4201)" width="3" height="5.75" fill="white"/>
//</mask>
//<rect width="64" height="64" fill="purple" mask="url(#myMask)"/>